import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from './api';

export default function KakaoCallbackPage({ getMyInfo, fcmToken, platform }) {
  const { search } = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const code = params.get('code');
    if (!code) { nav('/'); return; }

    (async () => {
      try {
        const redirectUri = window.location.origin + '/auth/kakao/callback';
        const { data } = await api.post('/auth/kakao/login', {
          code,
          redirectUri,
          fcm_token: fcmToken || null,
          platform: platform || null,
        });
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);
        await getMyInfo?.();
        nav('/'); // 원하는 페이지
      } catch (e) {
        console.error('kakao login failed', e);
        nav('/');
      }
    })();
  }, [search]);

  return null;
}